import { getDefaultConfirmation } from './get-default-confirmation';

export function getContent({ checkout, charge, email }) {
  if (checkout.redirectAfterPayment && checkout.redirectUrl) {
    if (checkout.customizeCheckoutConfirmation) {
      return {
        title: checkout.confirmationCheckoutTitle,
        message: checkout.confirmationCheckoutMessage,
      };
    }

    const defaultConfirmation = getDefaultConfirmation({
      checkout,
      charge,
      email,
    });

    return {
      title: defaultConfirmation.title,
      message: `${defaultConfirmation.message}

      You will be redirected in a few seconds.`,
    };
  }

  if (checkout.customizeCheckoutConfirmation) {
    return {
      title: checkout.confirmationCheckoutTitle,
      message: checkout.confirmationCheckoutMessage,
    };
  }

  const defaultConfirmation = getDefaultConfirmation({
    checkout,
    charge,
    email,
  });

  return defaultConfirmation;
}
